import React from 'react';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import { Form, Button } from 'react-bootstrap';
import { Card, CardBody, Col, Input } from 'reactstrap';

class RegistroUsuario extends React.PureComponent {

    constructor() {
        super();
        this.state = {
            rut: "",
            apellido: "",
            correo: "",
            pass: "",
            alertEnvioExitoso: false,
            nombre: "",
            segundaPass: "",
            dv: "",
            idSucursal: 0,
            sucursales: [],
            admin: false
        };
        this.handleChangeRut = this.handleChangeRut.bind(this);
        this.registrarUsuario = this.registrarUsuario.bind(this);
        this.formateaRut = this.formateaRut.bind(this);
        this.handleChangeNombre = this.handleChangeNombre.bind(this);
        this.handleChangeApellido = this.handleChangeApellido.bind(this);
        this.handleChangeCorreo = this.handleChangeCorreo.bind(this);
        this.usuarioAdministrador = this.usuarioAdministrador.bind(this);
        this.handleChangeCodigoDropBox = this.handleChangeCodigoDropBox.bind(this);
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleChangeSegundaPass = this.handleChangeSegundaPass.bind(this);
        this.traerSucursales = this.traerSucursales.bind(this);
    }

    componentDidMount(){
        this.traerSucursales();
    }

    traerSucursales(){

       var obj = {};
        try {
                axios.post('https://accesos.sanjoseapps.cl/api/traerSucursales.php', obj).then(response => {
                    const datos = response.data;
                    if (datos !== undefined) {
                        console.log(datos);
                      this.setState({sucursales: datos});
                    };
                });

        } catch (error) {
            console.log(error);
        }

    }

    handleChangeNombre(event) {
        event.preventDefault();
        this.setState({ nombre: event.target.value });
    }
    handleChangeApellido(event) {
        event.preventDefault();
        this.setState({ apellido: event.target.value });
    }
    handleChangeCorreo(event) {
        event.preventDefault();
        this.setState({ correo: event.target.value });
    }
    handleChangePass(event) {
        event.preventDefault();
        this.setState({ pass: event.target.value });
    }
    handleChangeSegundaPass(event) {
        event.preventDefault();
        this.setState({ segundaPass: event.target.value });
    }
    usuarioAdministrador() {
        if (this.state.admin) {
            this.setState({ admin: false });
        } else {
            this.setState({ admin: true });

        }
    }
    handleChangeCodigoDropBox(event){
        event.preventDefault();
        let valor = event.target.value
        this.setState({ idSucursal: valor });

    }

    registrarUsuario(event) {
        event.preventDefault();
        let estado
        if (this.state.admin) {
            estado = 1
        } else {
            estado = 0
        }
        var optionAxios = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        const obj = { correo: this.state.correo, pass: this.state.pass, apellido: this.state.apellido, nombre: this.state.nombre, rut: this.state.rut, estado: estado, idSucursal: this.state.idSucursal };

         try {
            if (this.state.segundaPass === this.state.pass) {
                axios.post('https://accesos.sanjoseapps.cl/api/registrarUsuario.php', obj, optionAxios).then(response => {
                    const datos = response.data;
                    if (datos !== undefined) {
                        console.log(datos);
                    this.setState({ alertEnvioExitoso: true });
                    setTimeout(() => { this.setState({ alertEnvioExitoso: false }) }, 10000)
                    };
               });
            } else {
                alert("Las contraseñas deben coincidir");
            }

          } catch (error) {
            console.log(error);
        }

    }


    handleChangeRut(event) {
        event.preventDefault();

        this.setState({ rut: (this.formateaRut(event.target.value)) });
    }

    formateaRut(rut) {
        if (rut !== undefined) {
            var actual = rut.replace(/^0+/, "");
            if (actual !== '' && actual.length > 1) {
                var sinPuntos = actual.replace(/\./g, "");
                var actualLimpio = sinPuntos.replace(/-/g, "");
                var inicio = actualLimpio.substring(0, actualLimpio.length - 1);
                var rutPuntos = "";
                var i = 0;
                var j = 1;
                for (i = inicio.length - 1; i >= 0; i--) {
                    var letra = inicio.charAt(i);
                    rutPuntos = letra + rutPuntos;
                    if (j % 3 === 0 && j <= inicio.length - 1) {
                        rutPuntos = "." + rutPuntos;
                    }
                    j++;
                }
                var dv = actualLimpio.substring(actualLimpio.length - 1);
                rutPuntos = rutPuntos + "-" + dv;
            }
            return rutPuntos

        }
    }

    render() {
        return (
            <React.Fragment>

                <Col md={12} lg={12}>
                    <Card>
                        <CardBody>
                            <div className="card__title">
                                <h4 className="bold-text">En esta pestaña se podrá crear un usuario</h4>
                            </div>
                            <Alert variant="success" show={this.state.alertEnvioExitoso} onClose={() => this.setState({ alertEnvioExitoso: false })} dismissible>
                                <Alert.Heading>¡Registro Exitoso!</Alert.Heading>
                                <p>
                                    Se ha registrado el usuario {this.state.nombre}.
                                </p>
                            </Alert>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div> <h4>RUT</h4> </div>
                                    <div>
                                        <Form.Control type="text" maxLength="12" field="rut" placeholder="RUT" value={this.state.rut} onChange={this.handleChangeRut} required />
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>
                                        <h4>     NOMBRES </h4>
                                    </div>
                                    <div>
                                        <Form.Control type="text" placeholder="Nombre" value={this.state.nombre} onChange={this.handleChangeNombre} maxLength={45} required />
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>
                                        <h4>     APELLIDOS</h4>
                                    </div>
                                    <div>
                                        <Form.Control type="text" placeholder="Apellido" maxLength={45} value={this.state.apellido} onChange={this.handleChangeApellido} required />
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>  <h4>  EMAIL </h4></div>
                                    <div>
                                        <Form.Control type="email" placeholder="Correo" value={this.state.correo} onChange={this.handleChangeCorreo} maxLength={45} required />
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>  <h4>  CONTRASEÑA </h4> </div>
                                    <div>
                                        <Form.Control type="password" placeholder="Contraseña" value={this.state.pass} onChange={this.handleChangePass} maxLength={45} required />
                                    </div>
                                </div>
                            </div>
                            <br></br>

                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>   <h4>  VALIDACIÓN CONTRASEÑA  </h4> </div>
                                    <div>
                                        <Form.Control type="password" placeholder="Validación Contraseña" value={this.state.segundaPass} onChange={this.handleChangeSegundaPass} maxLength={45} required />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>   <h4>  SUCURSAL </h4> </div>
                                    <div>
                                             <Form.Control as="select" id={"2"}  onChange={this.handleChangeCodigoDropBox} >
                                             < option key={0} value={-1}> { "Seleccione Sucursal"} </option>
                                            {this.state.sucursales.map((r) => {
                                                return (< option key={r.id_sucursal} value={r.id_sucursal}> { r.nombre} </option>)
                                            })}
                                        </Form.Control>

                                 </div>
                                </div>
                            </div>

                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>    </div>
                                    <div>
                                        <Input type="checkbox" onChange={e => this.usuarioAdministrador()} />  <h4> USUARIO ADMINISTRADOR  </h4>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-6" style={{ "marginLeft": "0" }}>
                                    <div>
                                        <Button onClick={this.registrarUsuario} > Registrar usuario </Button>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        )
    }
}

export default RegistroUsuario;
